import { writable } from "svelte/store";
/** Canvas state */
export const canvasWidth = writable(0);
export const canvasHeight = writable(0);
export const canvasTop = writable(0);
export const canvasRight = writable(0);
export const canvasBottom = writable(0);
export const canvasLeft = writable(0);
export const zoom = writable(100);
export const centerOffsetX = writable(0);
export const centerOffsetY = writable(0);
/** Image state */
export const imgNaturalWidth = writable(0);
export const imgNaturalHeight = writable(0);
export const imgWidth = writable(0);
export const imgHeight = writable(0);
export const imgX = writable(0);
export const imgY = writable(0);
/** MediaServerUrl */
export const hasMultipleChanges = writable(false);
export const mediaServerUrl = writable("https://media02.ogonline.nl");
export const userId = writable("546377ada0d4532643a552a8");
export const domain = writable("import");
export const objectType = writable("objectconsumer");
export const objectId = writable("5dc3db393ef8b518b4fa5d00");
export const modifiers = writable([]);
export const extension = writable("jpg");
export const importUrl = writable("https://images.realworks.nl/servlets/images/media.objectmedia/59745826.jpg?portalid=1689&check=api_sha256%3Ae25b863b6e4ccb1575cfaa752ee20fa725cbdad7e8f5d8c85ee939b5c51ad6ed");
export const file = writable("");
export function fromMSU(msu) {
    hasMultipleChanges.set(true);
    userId.set(msu.userId);
    domain.set(msu.domain);
    objectType.set(msu.objectType);
    objectId.set(msu.objectId);
    modifiers.set([]);
    hasMultipleChanges.set(false);
    if (msu.domain === "import") {
        file.set("");
        importUrl.set(msu.toImportUrl());
    }
    else {
        file.set(msu.file);
        importUrl.set("");
    }
}
